import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";

const KEY = "sc_smart_app_banner_dismissed_v1";

/** iOS Smart App Banner for mobile-web visitors (logged in or out). Mirrors the native
 *  "Open in the App / Get" prompt: only renders on an iPhone/iPad browser (not the installed
 *  PWA), once Ashley has a live Apple App Store link, and stays gone once dismissed. */
export default function SmartAppBanner() {
  const [apple, setApple] = useState("");
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });

  const isIOSWeb = (() => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    const iOS = /iPhone|iPad|iPod/i.test(ua) ||
      (/Macintosh/i.test(ua) && typeof document !== "undefined" && "ontouchend" in document); // iPadOS
    const standalone = (window.navigator && window.navigator.standalone) ||
      (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches);
    return iOS && !standalone;
  })();

  useEffect(() => {
    if (!isIOSWeb) return;
    api.get("/settings/app-links").then((r) => setApple(r.data?.apple || "")).catch(() => {});
  }, [isIOSWeb]);

  const close = () => { try { localStorage.setItem(KEY, "1"); } catch { /* noop */ } setDismissed(true); };

  if (!isIOSWeb || dismissed || !apple) return null;

  return (
    <div data-testid="smart-app-banner"
      className="relative z-[60] flex items-center gap-3 px-3 py-2 bg-slate-950/95 border-b border-white/10 backdrop-blur">
      <button onClick={close} data-testid="smart-app-banner-dismiss" aria-label="Dismiss"
        className="text-slate-500 hover:text-white p-1 shrink-0">
        <X className="w-4 h-4" />
      </button>
      <img src="/logo-mark.png" alt="Salesman Connect" className="w-11 h-11 rounded-[10px] shrink-0 shadow" />
      <div className="min-w-0 flex-1">
        <p className="text-white font-bold text-sm leading-tight truncate">Salesman Connect</p>
        <p className="text-[11px] text-slate-400 leading-tight truncate">High-ticket in-home sales jobs · Free</p>
      </div>
      <a href={apple} target="_blank" rel="noopener noreferrer nofollow" data-testid="smart-app-banner-open"
        className="shrink-0 rounded-full bg-violet-600 hover:bg-violet-500 text-white text-xs font-black uppercase tracking-wide px-4 py-1.5 transition-colors">
        Get
      </a>
    </div>
  );
}
